import type { estypes } from '@elastic/elasticsearch'

export const superNotionMetadataMapping = {
  icon: {
    type: 'keyword',
    index: false,
  },
} satisfies Record<string, estypes.MappingProperty>
